<script>
		import { user, game, view } from "../client.svelte.js";
		import Catalog from "../elements/Catalog.svelte";
		import ExhibCard from "../elements/ExhibCard.svelte";

		let grpdEntries = $derived(
			Object.groupBy(
		    ((user.isMaster) ?
			    user.exhibits.values().toArray() :
			    game.exhibits.map(exhibID => user.exhibits.get(exhibID)) )
				.map(exhib => Object.assign({}, exhib, {sectName: user.sections.get(`${exhib.advtID}-${exhib.sectID}`)?.name ?? exhib.sectID}))
			, (exhib => user.sections.get(`${exhib.advtID}-${exhib.sectID}`)?.name ?? exhib.sectID ?? "sonstige")
		) )

		// $inspect(`EXHIB-CATALOG - grpdEntries:`, grpdEntries)

    let groups = $derived(
			view.adventure.sections
				.map(sectID => user.sections.get(sectID))
        .filter(sect => sect.name in grpdEntries) )


		function view_exhibit(e) {
				view.exhibit = this
		}
</script>

<!-------------------------------- HTML -------------------------------------->

<article id="exhibits-catalog">
	<Catalog Card={ExhibCard} {grpdEntries} {groups} onselect={view_exhibit}/>
</article>